import React from "react";
import Parser from "html-react-parser";
import icon1 from "../../img/icon1.png";
import icon2 from "../../img/icon2.png";
import { FaCaretDown } from "react-icons/fa";
import Loading from "../../components/loading";
import CouponBuilderService from "../../services/coupon-builder";
import { IBenefitResponse } from "../../interfaces/benefit";
import { ICouponRequest, ICouponResponse } from "../../interfaces/coupon";
import { CSVLink } from "react-csv";
import MaskedInput from 'react-maskedinput';

export default class CouponBuilder extends React.Component<{ history: any }> {
    state = {
        benefits: [] as IBenefitResponse[],
        benefitId: "0" as string,
        quantity: 0 as number,
        expirationDate: "" as string,
        error: "" as string,
        success: false,
        isLoading: false,
        buildingCoupons: false,
        responseCoupon: [] as ICouponResponse[]
    };

    async componentDidMount() {
        this.setState({ isLoading: true });
        this.setState({ quantity: "" });
        var response = await CouponBuilderService.getBenefits();
        if (!response.data.error) {
            this.setState({ benefits: response.data });
            this.setState({ isLoading: false });
        }
    }

    clearValues = async (e: any) => {
        this.setState({ benefitId: e.target.value });
        this.setState({ quantity: "" });
        this.setState({ expirationDate: "" });
        this.setState({ error: "" });
        this.setState({ success: false });
    }

    validateExpirationDate = (date: string) => {
        if(!date){return ""};
        const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        const match = date.match(dateRegex);

        if (!match) {
            return "Data inválida. Use o formato dd/mm/yyyy.";
        }

        const [_, day, month, year] = match;

        if (parseInt(month) < 1 || parseInt(month) > 12) {
            return "Mês inválido. Deve ser entre 01 e 12.";
        }

        const daysInMonth = new Date(parseInt(year), parseInt(month), 0).getDate();
        if (parseInt(day) < 1 || parseInt(day) > daysInMonth) {
            return `Dia inválido. O mês ${month} tem no máximo ${daysInMonth} dias.`;
        }

        const expirationDate = new Date(`${year}-${month}-${day}`);
        const currentDate = new Date();

        if (expirationDate <= currentDate) {
            return "A data de expiração deve ser maior que a data atual.";
        }

        return "";
    };

    formatDateForBackend = (date: any) => {
        if (!date) {return null;}
        const [day, month, year] = date.split('/');
        return `${year}-${month}-${day}`; // Format: yyyy-MM-dd
    };

    handleBuildCoupons = async (e: any) => {
        e.preventDefault();

        if (this.state.quantity > 100000) {
            this.setState({ error: "A quantidade não pode ser maior que 100.000." });
            return;
        }

        if (this.state.expirationDate) {
            const expirationDateError = this.validateExpirationDate(this.state.expirationDate);
    
            if (expirationDateError) {
                this.setState({ error: expirationDateError });
                return;
            }
        }

        this.setState({ error: "" });
        if (this.state.benefitId === "0") {
            this.setState({ error: "Escolha um benefício!" });
        }
        else {
            try {
                this.setState({ buildingCoupons: true });
                const couponRequest = {
                    benefitId: this.state.benefitId,
                    quantity: this.state.quantity,
                    expirationDate: this.formatDateForBackend(this.state.expirationDate)
                } as ICouponRequest;

                var response = await CouponBuilderService.generateCoupons(couponRequest);
                this.setState({ responseCoupon: response.data });

                if (!response.data.error) {
                    this.setState({ buildingCoupons: false });
                    this.setState({ success: true });
                }
                else {
                    this.setState({ error: response.data.error.message });
                    this.setState({ buildingCoupons: false });
                }
            }
            catch (err) {
                this.setState({ error: "Houve um erro na geração dos vouchers." });
                console.log(err);
                this.setState({ buildingCoupons: false });
            }
        }
    };

    render() {
        const { isLoading, buildingCoupons, responseCoupon, error, success, quantity, expirationDate } = this.state;

        const headers = [
            { label: "Cupom", key: "coupom" }
        ];

        return (
            <div className="header__form">
                <a href="#" className="header__logo-1">
                    <img src={icon2} alt="" />
                </a>
                <a href="#" className="header__logo-2">
                    <img src={icon1} alt="" />
                </a>
                <div>
                    <p className="p-text">
                        Geração de vouchers Eurofarma
                    </p>
                    <form onSubmit={this.handleBuildCoupons}>
                        <div className="form-group">
                            <select
                                id="benefitId"
                                onChange={this.clearValues}
                                disabled={buildingCoupons || isLoading}
                            >
                                <option key="0" value="0">Benefício</option>
                                {
                                    this.state.benefits &&
                                    this.state.benefits.map(p =>
                                        <option key={p.benefitId} value={p.benefitId}>
                                            {p.benefit}
                                        </option>)
                                }
                            </select>
                            <span className="arrow-down"><FaCaretDown /></span>
                        </div>
                        <div className="form-group">
                            <input
                                id="quantity"
                                type="number"
                                placeholder="*Qtde"
                                disabled={buildingCoupons || isLoading}
                                min="1" 
                                max="100000"
                                maxLength={6}
                                onChange={e => this.setState({ quantity: e.target.value })}
                                required
                                value={quantity}
                            />
                        </div>
                        <div className="form-group">
                            <MaskedInput
                                id="expirationDate"
                                type="text"
                                mask="11/11/1111"
                                placeholderChar=" "
                                placeholder="Data de expiração"
                                onChange={e => {
                                    const expirationDate = e.target.value;
                                    this.setState({ expirationDate });
                                    const errorMessage = this.validateExpirationDate(expirationDate);
                                    if (errorMessage) {
                                        this.setState({ error: errorMessage });
                                    } else {
                                        this.setState({ error: "" });
                                    }
                                }}
                                disabled={buildingCoupons || isLoading}
                                value={expirationDate}
                            />
                        </div>

                        {error && (
                            <div className="h4 text-danger" style={{ marginBottom: '10px' }}>
                                {Parser(error)}
                            </div>
                        )}

                        <div className="form-button">
                            <button
                                id="submitButton"
                                type="submit"
                                className="btn-primary"
                                disabled={buildingCoupons || isLoading}
                            >
                                {buildingCoupons ? "Gerando vouchers..." : "Gerar"}
                            </button>
                            
                            {success && (
                                <div className="h4 text-success" style={{ marginTop: '10px' }}>
                                    Vouchers gerados com sucesso! <br />
                                    <CSVLink data={responseCoupon} headers={headers} target="_blank" filename="vouchers.csv">Exportar para o Excel</CSVLink>
                                </div>
                            )}
                        </div>
                    </form>
                </div>
                <Loading show={buildingCoupons || isLoading} />
            </div>
        );
    }
}
